import { Component } from '@angular/core';

@Component({
  selector: 'op-schedule-distribution',
  templateUrl: './schedule-distribution.component.html',
})
export class ScheduleDistributionComponent {
}
